import { Jumbotron } from './Jumbotron/Jumbotron';
import { Links } from './Links/Links';
import { View } from './MobileMenu.styles';

interface Props {
  onClickLink?: VoidFunction;
  onClickLogout?: VoidFunction;
  className?: string;
  showExternalActions?: boolean;
  showLoginsAndPolicyPopups?: boolean;
}

export const MobileMenu = ({
  onClickLogout,
  onClickLink,
  className,
  showExternalActions = true,
  showLoginsAndPolicyPopups = true,
}: Props) => (
  <View className={className} data-testid="mobileMenu">
    <Jumbotron
      onSelect={onClickLink}
      showExternalActions={showExternalActions}
      showLoginsAndPolicyPopups={showLoginsAndPolicyPopups}
    />
    <Links
      onSelect={onClickLink}
      showExternalActions={showExternalActions}
      onClickLogout={onClickLogout}
    />
  </View>
);
